import styled from '@emotion/styled';
import { tooltipClasses, TooltipProps, Tooltip } from '@mui/material';

interface CustomTooltipProps extends TooltipProps {
  className?: string;
}
const CustomTooltip = styled(({ className, ...props }: CustomTooltipProps) => (
  <Tooltip {...props} classes={{ popper: className ? className : undefined }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#FFFFFF',
    color: 'white',
    boxShadow: '2px 4px 20px rgba(0, 0, 0, 0.25)',
    borderRadius: '8px',
    maxWidth: 'none',
    width: '400px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#FFFFFF',
    fontSize: 'large',
  },
});

export default CustomTooltip;
